<div class="audit-log-container">
  <!-- Header -->
  <div class="d-flex justify-content-between align-items-center mb-3">
    <div>
      <h5 class="mb-1">Audit Log</h5>
      <p class="text-muted mb-0 small">
        View and track all administrative actions and changes made within your organization.
      </p><br>
      <p class="text-muted mb-0 small fst-italic">
        <strong>Note:</strong> If no date range is selected, the CSV export will default to the last 30 days.
      </p>
    </div>
    <div
      kendoTooltip
      [title]="exportTooltip()"
    >
      <button
        kendoButton
        [class.cyflare-btn-primary]="canExport()"
        [class.cyflare-btn-secondary]="!canExport()"
        (click)="triggerExport()"
        [disabled]="!canExport() || isExporting()"
      >
        @if (isExporting()) {
          <span class="spinner-border spinner-border-sm me-1" role="status"></span>
          Exporting...
        } @else {
          Export CSV
        }
      </button>
    </div>
  </div>

  <!-- Filter Bar -->
  <app-audit-log-filters
    [organizations]="organizations()"
    [isLoadingOrganizations]="isLoadingOrganizations()"
    [actions]="actions()"
    [outcomes]="outcomes()"
    [eventTypes]="eventTypes()"
    [userTypes]="userTypes()"
    (onApplyFilters)="onApplyFilters($event)"
    (onResetFilters)="onResetFilters()"
    (onOrganizationSearch)="onOrganizationSearch($event)"
  ></app-audit-log-filters>

  <!-- Datatable -->
  <div class="card">
    <div class="card-body">
      @if (isLoading()) {
        <div class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      } @else {
        <app-datatable
          #auditTable
          [data-href]="datatableUrl"
          [columns]="datatableColumns"
          [useOData]="true"
        ></app-datatable>
      }
    </div>
  </div>
</div>
